import { render } from "./VoucherBundleDetail.vue?vue&type=template&id=2df63ffe&scoped=true"
import script from "./VoucherBundleDetail.vue?vue&type=script&lang=js"
export * from "./VoucherBundleDetail.vue?vue&type=script&lang=js"

import "./VoucherBundleDetail.vue?vue&type=style&index=0&id=2df63ffe&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df63ffe"]])

export default __exports__